/**
 * Environment Configuration
 *
 * Centralizes all environment variable access to prevent scattered
 * process.env calls throughout the codebase.
 *
 * Benefits:
 * - Single source of truth for environment variables
 * - Easy to mock in tests
 * - Type safety (can add JSDoc or TypeScript later)
 * - Clear documentation of all required env vars
 */

export const config = {
  // Google Maps Configuration
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  googleMapsMapId: process.env.REACT_APP_GOOGLE_MAPS_MAP_ID,

  // AWS/Amplify Configuration
  // Note: This env variable doesn't follow REACT_APP_ convention
  // It's set by Amplify CLI during deployment
  userPoolId: process.env.AUTH_GAMMA6070A913_USERPOOLID,

  // Application Metadata
  commitId: process.env.REACT_APP_COMMIT_ID || 'dev',
  publicUrl: process.env.PUBLIC_URL || '',

  // Environment Flags
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
  isTest: process.env.NODE_ENV === 'test',
};

/**
 * Validate required environment variables
 * Throws error if critical variables are missing
 */
export function validateConfig() {
  const required = {
    REACT_APP_GOOGLE_MAPS_API_KEY: config.googleMapsApiKey,
    REACT_APP_GOOGLE_MAPS_MAP_ID: config.googleMapsMapId,
  };

  const missing = Object.entries(required)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  if (missing.length > 0) {
    console.warn(
      `Missing environment variables: ${missing.join(', ')}\n` +
      'Some features may not work correctly.'
    );
  }
}

// Validate on module load (development only)
if (config.isDevelopment) {
  validateConfig();
}
